import { StatusDot } from "@common/components/ui/status-dot"
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@common/components/ui/toggle-group"
import { TabText } from "@/components/layout/tab-text"

const TAB =
  "h-7 whitespace-nowrap px-3 text-small-regular data-[state=on]:bg-muted data-[state=on]:text-small-medium"

export function ListTabs<T extends string>({
  tabs,
  tab,
  label,
  name,
  marked,
  markLabel = () => "Values to check",
  reselect = false,
  onSelect,
}: {
  tabs: readonly T[]
  tab: T
  label: (tab: T) => string
  name?: string
  marked?: (tab: T) => boolean
  markLabel?: (tab: T) => string
  reselect?: boolean
  onSelect: (next: T) => void
}): React.ReactElement {
  return (
    <ToggleGroup
      type="single"
      aria-label={name}
      value={tab}
      onValueChange={(next) => {
        const picked = tabs.find((candidate) => candidate === next)
        if (picked) onSelect(picked)
        else if (reselect) onSelect(tab)
      }}
      size="sm"
      className="w-max justify-start"
    >
      {tabs.map((value) => (
        <ToggleGroupItem key={value} value={value} className={TAB}>
          <TabText>{label(value)}</TabText>
          {marked?.(value) && (
            <>
              <StatusDot tone="warning" />
              <span className="sr-only">{markLabel(value)}</span>
            </>
          )}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
